export default "__VITE_ASSET__CZzIE_cZ__"